export default "__VITE_ASSET__VIeLoBme__"